module.exports = __webpack_public_path__ + "static/media/advertencia4.aa63231a.PNG";